export class GeneralError extends Error {
  showTryAgain: boolean;
  code: string;
  constructor(message = "Please try again.", showTryAgain = false, code = "") {
    super(message);
    this.name = "GeneralError";
    this.showTryAgain = showTryAgain;
    this.code = code;
  }
}
